import Banner from "../components/About/Banner/Banner";
import Vision from "../components/About/Vision/Vision";
import History from "../components/About/History/History";
import HelmetLayout from "../components/GlobalComponents/HelmetLayout";

const About = () => {
    return (
        <HelmetLayout
            name="About"
            title="About Ard Altaamir | Certified Experts with Guaranteed Quality"
            description="Ard Altaamir is a certified renovation and maintenance company delivering guaranteed quality in plumbing, electrical, MEP, and construction works. Trusted by clients across the region."
            route="about"
        >
            <Banner />
            <Vision />
            <History />
        </HelmetLayout>
    );
};

export default About;
